import { Modal } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import "../../../payements/utils/paiement.css";
import jsPDF from "jspdf";
import toast from "react-hot-toast";
import { generateReceiptPDF } from "../generateReceiptPDF";


const DetailRecuVersement = ({ isOpen, toggle, selectedVersement }) => {
  if (!selectedVersement) return null;

  const {
    id,
    createdAt,
    paymentMethodName,
    clientNumber,
    prefixPhone,
    amount,
    realAmount,
    currency,
    merchantAccountName,
    developerAccountName,
    description,
    transactionReference,
    status,
    clientFullName
  } = selectedVersement;

  const formatDate = (timestamp) => dayjs(Number(timestamp)).format("DD-MM-YYYY");

  const handleDownload = async () => {
    await generateReceiptPDF({
      id,
      createdAt,
      paymentMethodName,
      clientNumber,
      prefixPhone,
      amount,
      currency,
      merchantAccountName,
      developerAccountName,
      description,
      transactionReference,
      formatDate,
      status,
      clientFullName
    });

    toast.success("Reçu généré avec succès");
  };

  return (
    <Modal
      open={isOpen}
      onCancel={toggle}
      footer={null}
      centered
      width={500}
      className="modal-detail-payment"
    >
      <h2 className="modal-title">Information de la transaction</h2>

      <div className="payment-details">
        <div className="payment-row">
          <span className="label">Bénéficiare</span>
          <span className="value">{merchantAccountName}</span>
        </div>

        <div className="payment-row">
          <span className="label">Business</span>
          <span className="value">{developerAccountName}</span>
        </div>

        <div className="payment-row">
          <span className="label">{paymentMethodName === "BANK" ? "Numero Compte" : "Téléphone"}</span>
          <span className="value">{paymentMethodName !== "BANK" ? "+" : ""}{prefixPhone} {clientNumber}</span>
        </div>

        <div className="payment-row">
          <span className="label">Date de paiement</span>
          <span className="value">{formatDate(createdAt)}</span>
        </div>

        <div className="payment-row">
          <span className="label">Montant</span>
          <span className="value">{amount?.toLocaleString()} {currency}</span>
        </div>

        <div className="payment-row">
          <span className="label">Moyen de paiement</span>
          <span className="value">{paymentMethodName === "BANK" ? "Virement bancaire" : paymentMethodName === "WAVESN" ? "Wave" : paymentMethodName === "OMSN" ? "Orange money" : "Non défini" }</span>
        </div>

        <div className="payment-row">
          <span className="label">Client</span>
          <span className="value">{clientFullName ? clientFullName : "Aucun nom renseigné"}</span>
        </div>

        {description && (
          <div className="payment-row">
            <span className="label">Description</span>
            <span className="value">{description}</span>
          </div>
        )}

        {transactionReference && (
          <div className="payment-row">
            <span className="label">Reference</span>
            <span className="value">{transactionReference}</span>
          </div>
        )}
      </div>

      <button className="btn-download-paiement" onClick={handleDownload}>
        <DownloadOutlined style={{ marginRight: 8 }} />
        Télécharger le reçu
      </button>
    </Modal>
  );
};

export default DetailRecuVersement;
